import { observer } from 'mobx-react';
import { FC, useCallback, useMemo } from 'react';
import kioskEditStore from '../../store/kioskEditStore';
import { localeStore } from '~/mobx/localesStore';
import { TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/types/customTooltip';
import Picker from '~/view/components/Controls/Pickers/Picker/Picker';
import { KioskMultiplierOptions } from '~/view/screens/SettingsScreen/screens/Devices/screens/KioskEditScreen/constants/kiosks';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import { getLastArrayItem } from '~/utils/helpers';
import TooltipIcon from '~/view/components/TooltipIcon/TooltipIcon';

const KioskMultiplier: FC = observer((): JSX.Element => {
  const handleMultiplierChange = useCallback((options: IPickerOption[]) => {
    const { value } = getLastArrayItem<IPickerOption>(options) || {};
    kioskEditStore.changeEditableKiosk({ kiosk_terminal_multiplier: value });
  }, []);

  const selectedPickerOption = useMemo(() => {
    const { kiosk_terminal_multiplier } = kioskEditStore.editableKiosk;
    return [{ label: String(kiosk_terminal_multiplier), value: Number(kiosk_terminal_multiplier) }];
  }, [kioskEditStore.editableKiosk]);

  return (
    <div className="kiosk__field">
      <div className="position-relative align-items-center">
        <div className="kiosk__field-title">
          <div className="d-flex multiplier-title">
            {localeStore.t('kiosk_terminal_multiplier_input_hdr')}
            <TooltipIcon
              message="kiosk_terminal_multiplier_input_hint"
              position={TOOLTIP_POSITION.FIXED}
              wrapperClassName="terminal_multiplier_icon pl-2"
            />
          </div>
        </div>
      </div>
      <div className="d-flex flex-column">
        <Picker
          options={KioskMultiplierOptions}
          selectedOptions={selectedPickerOption}
          hideResetIcon
          noReset
          placeholder={localeStore.t('select_availability')}
          listClassName="branches-header__filter"
          onSelect={handleMultiplierChange}
        />
      </div>
    </div>
  );
});
export default KioskMultiplier;
